import { FormFieldSelect } from 'global/components/Form'

interface IProps {
    required?: boolean
}

export function SelectTipoDocumento({ required }: IProps) {
    return (
        <FormFieldSelect
            required={required}
            name="tipoDocumento"
            label="Tipo de documento"
            className="min-w-0"
            options={[
                { value: 'CNPJ', label: 'CNPJ' },
                { value: 'CAEPF', label: 'CAEPF' },
                { value: 'CPF', label: 'CPF' },
            ]}
        />
    )
}
